export enum CookiesKeys {
  COMSCORE = 'cs_fpid',
  PROVIDER_TOKEN = 'providerToken',
  REGION = 'region',
  REGION_REDIRECT = 'region-redirect'
}
